import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

const userRightsSlice = createSlice({
  name: "userRights",
  initialState: {
    rights: [],
    hcUserId: null,
  },
  reducers: {
    setUserRights: (state, action) => {
      state.rights = action.payload;
    },

    setHcUserId: (state, action) => {
      state.hcUserId = action.payload;
    },
  },
});

export const { setUserRights, setHcUserId } = userRightsSlice.actions;
export default userRightsSlice.reducer;
